<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.actions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-12 md:gap-6">
            <div class="col-span-6">
                <NavLinks :links="meta.navGroupLinks" />
            </div>
            <div class="col-span-4">
                <StudentSelectorSlideOver v-model="form.student_ids" :students="students" with-count />
            </div>
            <div class="sm:col-span-2">
                <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                <div class="mt-1">
                    <form action="" @submit.prevent="filter()">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </form>
                </div>
            </div>
        </div>

        <EmptyState picture v-if="!actionLogs.data.length">
            <template v-slot:picture />
        </EmptyState>
        <div class="flex flex-col mt-5" v-else>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.actions', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.student') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.when') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(actionLog, index) in actionLogs.data"
                                :key="index"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex flex-col md:flex-row gap-2 flex-col-reverse">
                                        <div>
                                            <BadgePill :color="actionLog.type_color">
                                                {{ actionLog.type_display }}
                                            </BadgePill>
                                        </div>
                                        <div>
                                            {{ actionLog.name_display }}
                                        </div>
                                    </div>
                                </td>
                                <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-500">
                                    {{ actionLog.description }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ actionLog.student_name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ actionLog.created_at_display }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="actionLogs" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import BadgePill from '@/components/BadgePill.vue';
import EmptyState from '@/components/EmptyState.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import StudentSelectorSlideOver from '@/components/StudentSelectorSlideOver.vue';
import NavLinks from '@/components/NavLinks.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        BadgePill,
        EmptyState,
        InertiaPagination,
        StudentSelectorSlideOver,
        NavLinks,
    },
    layout: Layout,
    name: 'Index',
    props: ['filters', 'meta', 'options', 'actionLogs', 'students', 'gamificationSet'],
    data() {
        return {
            form: this.$inertia.form({
                student_ids: this.filters.student_ids,
                group_id: this.filters.group_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
    computed: {},
};
</script>
